export default
{
    props:
    {
        text: { type: String, default: '' }
    },

    data()
    {
        return {
            src: ''
        }
    },

    created()
    {
        this.src = this.text.match(/<img.*?src=['"](.*?)['"]/)[1]
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/core-parse-img/script.js